import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { getAllEmployees, getProjects } from "../redux/actionCreator";
import { useNavigate } from "react-router-dom";
import SideMenu from "./SideMenu";
import Projects from "./Projects";

export default function Dashboard() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  return (
    <div className="admin__dashboard">
      <div className="container">
        <div className="row">
          <div className="col-md-4">
           <SideMenu />
          </div>
          <div className="col-md-8">
            <Projects />
          </div>
        </div>
      </div>
    </div>
  );
}
